import React from 'react';
import { Button } from 'tea-component';
import { IFormattedFilter } from '../_type';
import FilterIcon from './FilterIcon';
import EllipsisHover from '@gp/components/EllipsisHover';

interface IFilterSelectorProps {
  filter: IFormattedFilter;
  selectedValues: string[];
  onToggle: (value: string) => void;
}

/**
 * 筛选器选择器组件
 */
const FilterSelector: React.FC<IFilterSelectorProps> = ({
  filter,
  selectedValues,
  onToggle,
}) => {
  // 如果选项少于等于1个，不显示
  if (filter.options.length <= 1) {
    return null;
  }

  return (
    <div className="dba-download-settings-item">
      {/* <div className="dba-download-settings-label">
        {filter?.name || filter?.data_key}
      </div> */}
      <EllipsisHover  className="dba-download-settings-label" text={filter?.name || filter?.data_key} />
      <div className="dba-download-settings-tag-list">
        {filter.options.map((option) => {
          const isActive = selectedValues.includes(option.value);

          return (
            <Button
              key={option.value}
              type={isActive ? 'primary' : 'weak'}
              className={`dba-download-settings-tag ${isActive ? 'dba-download-settings-tag--active' : ''}`}
              onClick={() => onToggle(option.value)}
            >
              <span className="dba-download-settings-tag-icon-wrapper">
                <FilterIcon dataKey={filter.data_key} option={option} isActive={isActive} />
              </span>
              <span className="dba-download-settings-tag-text">{option.text}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterSelector;

